export default 1.06587629952346;
